import React from "react";
import { FormControl, FormLabel, Input, FormErrorMessage } from "@chakra-ui/react";

const FormInput = ({field, label, errors, register, disabled, onChange, isPassword, style}: any) => {
    return <FormControl isInvalid={!!errors} className="mb-5">
        <FormLabel>{label}</FormLabel>
        <Input style={style} disabled={disabled} readOnly={disabled} onChange={onChange} type={isPassword ? "password" : "text"} {...register(`${field}`)}/>
        {errors &&  <FormErrorMessage className="mt-0">{errors?.message}</FormErrorMessage>}
    </FormControl>
}
export default FormInput;